document.addEventListener('DOMContentLoaded', function() {
    fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=6485ae20faa76cdda508dca5&locale=${window.Shopify.locale}-${window.Shopify.country}`)
    .then(response => response.json())
    .then(response => {
        document.querySelectorAll('.trustCount').forEach(el => el.innerHTML = response.businessUnit.numberOfReviews.total);
        document.querySelectorAll('.trustStar').forEach(el => el.innerHTML = response.businessUnit.trustScore);
        
    })

    function equalizeColumnHeights() {
        const gallery = document.querySelector('.product-gallery');
        const info = document.querySelector('.product-info');
        if (info && gallery) {
            const smallerHeight =  info.scrollHeight;
            
            gallery.style.maxHeight = `${smallerHeight}px`;
            
        }
    }
    equalizeColumnHeights();

    // Run on page load and resize
    window.addEventListener('load', equalizeColumnHeights);
    window.addEventListener('resize', equalizeColumnHeights);
    
}); 